<div class="santa-inline-block santa-w-full santa-border" [class.invalid]="invalid" [class.select-closed]="!state?.opened" [class.hide-closed-border]="!enableClosedBorder">
  <santa-drop-down
    [class.santa-pointer-events-none]="!openWithOneItem && state?.items?.length === 1"
    [buttonContent]="current"
    [dropDownContent]="dropDownContent"
    [direction]="dropDownDirection"
    [verticalDirection]="dropDownVerticalDirection"
    [showArrow]="showArrow"
    [hideDivider]="hideDivider"
    [contentFullWidth]="contentFullWidth"
    [initOnStart]="true"
    [opening]="state.opened"
    (openedChanges)="onOpenedChanges($event)"
  ></santa-drop-down>
</div>

<ng-template #current>
  <div class="santa-relative santa-cursor-pointer">
    <label
      *ngIf="label"
      class="select-label {{ state?.selectedItem ? 'santa-typo-small' : 'santa-typo-regular' }}"
      [class.required]="isRequired"
      [class.filled]="!withoutPreselected || state?.selectedItem"
      [class.invalid]="invalid"
      for
    >
      {{ label }}
    </label>

    <ng-container *ngIf="state?.selectedItem as selectedItem">
      <ng-container *ngIf="getContent(selectedValueContent || itemContent, selectedItem) as selectedTemplate">
        <ng-container *polymorpheusOutlet="selectedTemplate as primitiveSelected; context: selectedItem">
          <p
            *ngIf="primitiveSelected"
            class="
              santa-m-0 santa-py-10 santa-pr-0 santa-pl-20 santa-box-border santa-typo-regular santa-text-black-700
            "
          >
            {{ primitiveSelected }}
          </p>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #dropDownContent>
  <div
    class="santa-py-10 santa-bg-white santa-z-20 santa-overflow-y-auto {{ verticalDirectionConfig[dropDownVerticalDirection] }}"
    [ngClass]="{ 'select-divider': enableOpenedDivider }"
    [ngStyle]="{ 'max-height': dropDownMaxHeight }"
  >
    <div *ngFor="let item of state.items; trackBy: trackByIndex" [ngClass]="{ 'select-item-selected': item.active }" (click)="onItemClick(item)" class="select-item-container">
      <ng-container *ngIf="getContent(itemContent, item) as contentTemplate">
        <ng-container *polymorpheusOutlet="contentTemplate as primitiveItem; context: item.$implicit | contextToImplicit">
          <p *ngIf="primitiveItem" class="santa-m-0 santa-p-10 santa-typo-regular santa-text-black-700">
            {{ primitiveItem }}
          </p>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>
